module.exports = __webpack_public_path__ + "static/covid-fade-794148e6778d4d0285b36a43b20c8455.mp4";